(() => {
  "use strict";

  const money = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  const number = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 1 });

  function updateQuantity(summary, input) {
    const quantity = Math.max(1, Number(input?.value || 1));
    const stage = summary.dataset.stageLabel || "Einheit";
    const pluralStage = quantity === 1
      ? stage
      : stage === "Halbe Palette"
        ? "Halbe Paletten"
        : stage === "Ganze Palette"
          ? "Ganze Paletten"
          : stage;
    const bales = Number(summary.dataset.ballCount || 0) * quantity;
    const weight = Number(summary.dataset.weightKg || 0) * quantity;
    const total = Number(summary.dataset.unitPriceCents || 0) * quantity / 100;
    const title = summary.querySelector("[data-ls-qm-quantity-title]");
    const detail = summary.querySelector("[data-ls-qm-quantity-total]");
    const price = summary.querySelector("[data-ls-qm-quantity-price]");
    if (title) title.textContent = quantity + " × " + pluralStage;
    if (detail) detail.textContent = bales + " Ballen · ca. " + number.format(weight) + " kg";
    if (price) price.textContent = money.format(total);
  }

  function initializeQuantity(scope = document) {
    const summaries = scope.querySelectorAll("[data-ls-qm-quantity-summary]");
    for (const summary of summaries) {
      if (summary.dataset.ready === "true") continue;
      summary.dataset.ready = "true";
      const form = summary.closest("form");
      const input = form?.querySelector('input[name="quantity"]');
      if (!input) continue;
      const refresh = () => updateQuantity(summary, input);
      input.addEventListener("input", refresh);
      input.addEventListener("change", refresh);
      form.addEventListener("click", (event) => {
        if (event.target.closest("quantity-selector .plus, quantity-selector .minus")) setTimeout(refresh, 0);
      });
      refresh();
    }
  }

  function initialize(scope = document) {
    const roots = scope.querySelectorAll("[data-ls-qm-variant-selector]");
    for (const root of roots) {
      if (root.dataset.lsQmVariantSelectorReady === "true") continue;
      root.dataset.lsQmVariantSelectorReady = "true";
      document.body.classList.add("ls-qm-product-page");
      root.closest(".thb-product-detail")?.classList.add("ls-qm-product-detail");

      const summary = root.closest(".summary.entry-summary");
      const description = summary?.querySelector(".product-short-description");
      if (description && (description.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        description.before(root);
      }

      if (root.dataset.multipleVariants !== "true") continue;
      const cards = Array.from(root.querySelectorAll(".ls-qm-variant-card"));
      const expectedCount = Number(root.dataset.variantCount || 0);
      const complete = root.dataset.completeVariants === "true" && cards.length === expectedCount;
      if (complete && summary) summary.classList.add("ls-qm-has-visual-variants");

      for (const card of cards) {
        card.addEventListener("click", () => {
          const stage = card.dataset.deliveryStage;
          const gallery = document.querySelector("ls-heulage-gallery");
          const tab = stage ? gallery?.querySelector('[data-gallery-target="delivery-' + stage + '"]') : null;
          if (stage && tab && typeof gallery.select === "function") gallery.select("delivery-" + stage, tab, false);
          root.classList.add("is-loading");
          root.setAttribute("aria-busy", "true");
        });
      }
    }
    initializeQuantity(scope);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialize());
  else initialize();
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  window.addEventListener("pageshow", () => initialize());
})();
